module.exports = __webpack_public_path__ + "images/list-92848b86.svg";